import { publishErrorUnlessSuccess, hFetch, type HError } from './hFetch';

// 1 is hardcoded for now until the API is updated to utilize the current user as a resource
// will not affect desired result
export const getUser = async ({ id } = { id: 1 }) => {
  const data = await hFetch({ url: `/api/users/${id}` });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Get User' });
  return data;
};

export const getUserDetails = async () => {
  const data = await hFetch({ url: `/api/users/details` });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Get User Details' });
  return data;
};

export const getUserCalendarAuthStatus = async ({ id }: { id: string }) => {
  const data = await hFetch({ url: `/api/users/${id}/is_calendar_authenticated` });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Get Calendar Info' });
  return data;
};

export const verifyUserEmail = async ({ id } = { id: 1 }) => {
  const data = await hFetch({ url: `/api/users/${id}/verify_email`, method: 'POST' });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Verify Email' });
  return data;
};

export const resendEmailConfirmation = async ({ id } = { id: 1 }) => {
  const data = await hFetch({ url: `/api/users/${id}/resend_email_confirmation`, method: 'POST' });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Resend Email Confirmation' });
  return data;
};

export const updateUser = async (
  { id }: { id: string },
  { updatedUserAttributes }: { updatedUserAttributes: User }
) => {
  const data = await hFetch({ url: `/api/users/${id}`, method: 'PATCH', payload: updatedUserAttributes });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Update User' });
  return data;
};

export const createUser = async (newUserAttributes: CreateUser) => {
  const data = await hFetch({ url: `/api/users`, method: 'POST', payload: newUserAttributes });
  publishErrorUnlessSuccess({ data: data as unknown as HError, alertTitle: 'Failed to Create User' });
  return data;
};

type User = {
  email: string;
  first_name: string;
  last_name: string;
  mobile_phone_number: string;
};

type CreateUser = {
  email: string;
  role: string;
};
